<script setup>

</script>

<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 21L20.1314 16.7916C20.4469 16.6283 20.6047 16.5467 20.7198 16.4264C20.8217 16.32 20.899 16.1924 20.9464 16.0526C21 15.8945 21 15.7167 21 15.3611C21 13.6519 21 10.0684 21 7.53273M12 21L3.86859 16.7916C3.55308 16.6283 3.39532 16.5467 3.28016 16.4264C3.17831 16.32 3.10095 16.1924 3.05357 16.0526C3 15.8945 3 15.7159 3 15.3587V7.53273M12 21C12 21 12 15.4766 12 11.9374M21 7.53273C17.4853 9.25286 15.5147 10.2173 12 11.9374M21 7.53273C18.2435 6.10609 15.487 4.67946 12.7304 3.25282C12.4632 3.11451 12.3296 3.04536 12.1888 3.0181C12.0641 2.99397 11.9359 2.99397 11.8112 3.0181C11.6704 3.04536 11.5365 3.11468 11.2686 3.25332L3 7.53273M3 7.53273C6 9.00095 9 10.4692 12 11.9374" stroke="#020618" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<style scoped>

</style>
